import React from "react"
import LabelComponent from "./LabelComponent"

export default function InputTextComponent({
  title,
  type,
  placeholder,
  onChange,
  value,
  required,
  slug,
  centerPlaceholder,
  className = "",
  disabled = false,
  ...rest
}) {
  return (
    <>
      <LabelComponent className={`inputtextcomponent-label-${slug}   `} {...rest} title={title} required={required} />
      <div>
        <input
          className={`inputtextcomponent-input-${slug} ${centerPlaceholder ? "center_placeholder" : ""} text-input ${className}`}
          // required={required}
          type={type || "text"}
          placeholder={placeholder}
          onChange={onChange}
          value={value}
          disabled={disabled}
        />
      </div>
    </>
  )
}
